import {
  animate,
  keyframes,
  state,
  style,
  transition,
  trigger
} from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import {
  InvoiceInfo,
  InvoiceInfoRes,
  PaymentTypes,
  genMatOption,
  paymentHistory,
  transaction
} from 'src/app/constants/constants';
import { GlobalApiService } from 'src/app/services/global-api.service';
import * as kf from './keyframes';
import { NotifierService } from 'angular-notifier';
import * as moment from 'moment';
import { CommonService } from 'src/app/services/common.service';
import { error } from 'pdf-lib';
import { StripePaymentService } from 'src/app/services/stripe-payment.service';
import { Router, ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-student-payment',
  templateUrl: './student-payment.component.html',
  styleUrls: ['./student-payment.component.scss'],
  animations: [
    trigger('cardAnimator', [
      transition('* => enter', [
        style({
          opacity: 0
        }),
        animate(
          '1s ease-in',
          style({
            opacity: 1
          })
        )
      ]),
      transition('* => leave', [
        style({
          opacity: 1
        }),
        animate(
          '1s ease-out',
          style({
            opacity: 0
          })
        )
      ])
      // transition('* => wobble', animate(1000, keyframes(kf.wobble))),
      // transition("* => swing", animate(1000, keyframes(kf.swing))),
      // transition('* => jello', animate(1000, keyframes(kf.jello))),
      // transition('* => zoomOutRight', animate(1000, keyframes(kf.zoomOutRight))),
      // transition('* => slideOutLeft', animate(1000, keyframes(kf.slideOutLeft))),
      // transition('* => rotateOutUpRight', animate(1000, keyframes(kf.rotateOutUpRight))),
      // transition('* => flipOutY', animate(1000, keyframes(kf.flipOutY))),
    ])
  ]
})
export class StudentPaymentComponent implements OnInit {
  showDuePaymentModal: boolean = false;
  isStudent: boolean = true;
  isMobile: boolean = window.innerWidth < 540;

  paymentJson: any[] = [
    {
      student: 'John',
      description: 'SAT',
      amount: '50 USD',
      status: 'Pending 30th June, 2023',
      paymentMethod: '-',
      paidOn: '-'
    },
    {
      student: 'Ravi',
      description: 'ACT',
      amount: '200 USD',
      status: 'Completed',
      paymentMethod: 'Paypal',
      paidOn: '31 Jan 2023'
    },
    {
      student: 'Aida Bugg',
      description: 'Academic Math',
      amount: '250 USD',
      status: 'Pending 24th July, 2023',
      paymentMethod: '-',
      paidOn: '-'
    },
    {
      student: 'Maureen',
      description: 'ACT',
      amount: '500 USD',
      status: 'Pending 12th Aug, 2023',
      paymentMethod: '-',
      paidOn: '-'
    },
    {
      student: 'Allie Grater',
      description: 'Reading and Writing',
      amount: '100 USD',
      status: 'Completed',
      paymentMethod: 'G-Pay',
      paidOn: '2nd Feb 2023'
    }
  ];

  paymentTypes: PaymentTypes[] = [];

  invoiceInfoList: InvoiceInfoRes = {
    totalElements: 0,
    invoiceInfoList: []
  };

  payNowContent: InvoiceInfo | null = null;

  mobileViewContent: InvoiceInfo | null = null;

  mobileViewCompareList = [
    'Student',
    'Description',
    'Amount',
    'Paid Amount',
    'Due Amount',
    'Status',
    'Payment Method',
    'Due By'
    // 'Paid For',
  ];

  index: number = 0;

  animationState: string = '';

  getPaymentUrlClicked: boolean = false;
  notifier: NotifierService;

  numbers: number[] = [2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

  selectedInvoice: InvoiceInfo | null = null;
  showLoader: boolean = false;

  paymentOptions: any[] = [
    { label: 'Installments', value: 1 },
    { label: 'Pay In Full', value: 0 }
  ];

  isPaymentOrInstallment: number = 0;
  isFullPayment: boolean = false;
  isInstallment: boolean = false;
  installmentNumber: number = 2;
  // ** By default (Monthly - value = 3)
  installmentPlan: number = 3;
  installmentStartDate: string = moment().format('MM-DD-YYYY');
  installmentEndDate: string = moment().format('MM-DD-YYYY');
  nextInstallmentDate: string = moment().format('MM-DD-YYYY');
  showPayNowDueModel: boolean = false;
  showTAndCModal: boolean = false;
  paymentCardClicked: boolean = false;

  paymentHistory: InvoiceInfo | null = null;

  installmentOptions: genMatOption[] = [
    { value: 2, displayValue: 'Weekly' },
    // { value: 1, displayValue: 'Bi-Weekly' },
    { value: 3, displayValue: 'Monthly' },
    // { value: 3, displayValue: '2 Months' },
    // { value: 4, displayValue: '3 Months' },
    // { value: 5, displayValue: '5 Months' },
    // { value: 5, displayValue: '6 Months' },
    { value: 4, displayValue: 'Yearly' }
  ];

  installmentDates: string[] = [];

  termCheck1: boolean = false;

  isSideNavbarCollapsed: boolean = false;
  successfulTransactions: transaction[] = [];

  constructor(
    private globalApiService: GlobalApiService,
    notifierService: NotifierService,
    private commonService: CommonService,
    private stripePaymentServcie: StripePaymentService,
    private router: Router,
    private route: ActivatedRoute
  ) {
    this.notifier = notifierService;
    this.route.queryParams.subscribe((params: Params) => {
      console.log('query params are: ', params);
      if ('paymentMethodUpdate' in params) {
        if (params?.['paymentMethodUpdate'] === 'success') {
          if (
            localStorage.getItem('invoiceId') !== null &&
            localStorage.getItem('cSessionId') !== null
          ) {
            this.confirmTheUpdatePaymentMethod();
          }
        } else {
          this.notifier.notify('error', 'Payment Method Update Failed.');
        }
      }
    });
  }

  ngOnInit(): void {
    this.getInvoiceInfoList();
    // this.getPaymentTypes();
    this.commonService.getSideBarCollapsedState().subscribe({
      next: (res: boolean) => {
        this.isSideNavbarCollapsed = res;
      },
      error: (err) => {
        console.log(
          'Unable to get the state of sideNavbarCOllapsed or not.. => ',
          err
        );
      }
    });
  }

  // getPaymentTypes() {
  //   this.globalApiService.getPaymentTypes().subscribe({
  //     next: (res: PaymentTypes[]) => {
  //       console.log(`payment types ------------> : ${res}`);
  //       this.paymentTypes = res;
  //     },
  //     error: (err) => {
  //       console.log(err);
  //     },
  //   });
  // }

  startAnimation(state: any) {
    console.log(state);
    if (!this.animationState) {
      this.animationState = state;
    }
  }

  resetAnimationState() {
    this.animationState = '';
  }

  getInvoiceInfoList() {
    this.showLoader = true;
    this.isStudent = localStorage['roleId'] === '3' ? true : false;
    this.globalApiService.getInvoiceInfoList(this.isStudent).subscribe({
      next: (res: InvoiceInfoRes) => {
        console.log(res);
        this.invoiceInfoList = res;
        // ** Just for testing purposes
        // this.invoiceInfoList.invoiceInfoList[0].status = '11';
        this.mobileViewContent = this.invoiceInfoList.invoiceInfoList[0];
        console.log('mobile view content', this.mobileViewContent);
        this.invoiceInfoList.invoiceInfoList.forEach(
          (invoiceInfo, invoiceInfoIndex) => {
            invoiceInfo.dueDate = moment(
              invoiceInfo.dueDate,
              'MM-DD-YYYY'
            ).format('MM-DD-YYYY');
            if (
              invoiceInfo.paymentDetails.transactions === null ||
              invoiceInfo.paymentDetails.transactions === undefined
            ) {
              invoiceInfo.paymentDetails.transactions = [];
            } else {
              invoiceInfo.paymentDetails.transactions =
                invoiceInfo.paymentDetails.transactions.filter(
                  (transaction) =>
                    transaction.paymentStatus !== 6 &&
                    transaction.paymentStatus !== 10
                );
            }
            invoiceInfo.paymentDetails.transactions.forEach(
              (transaction, transactionIndex) => {
                transaction.transactionDate = moment(
                  transaction.transactionDate
                ).format('MM-DD-YYYY');
              }
            );
          }
        );
        this.showLoader = false;
      },
      error: (err) => {
        this.showLoader = false;
        console.log(err);
      }
    });
  }

  getPaymentStatus(paymentStatus: string | number): string {
    paymentStatus = paymentStatus.toString();
    let returnPaymentStatus: string = '';
    returnPaymentStatus =
      paymentStatus === '1' || paymentStatus === '2' || paymentStatus === '7'
        ? 'Pending'
        : paymentStatus === '6' || paymentStatus === '10'
          ? 'Processing'
          : paymentStatus === '3'
            ? 'Paid'
            : paymentStatus === '4' || paymentStatus === '9'
              ? 'Failed'
              : paymentStatus === '8'
                ? 'Subscription'
                : paymentStatus === '11'
                  ? 'Partial'
                  : paymentStatus === '12'
                    ? 'Completed'
                    : paymentStatus === '15'
                      ? 'Subscription Cancelled'
                      : paymentStatus === '16' || paymentStatus === '17'
                        ? 'In Progress'
                        : paymentStatus === '6' || paymentStatus === '10'
                          ? 'Processing'
                          : 'Paid';
    return returnPaymentStatus;
  }

  getPaymentSpan(paymentStatus: string | number): string {
    paymentStatus = paymentStatus.toString();
    let returnPaymentSpan = '';
    returnPaymentSpan =
      paymentStatus === '8'
        ? 'Active'
        : paymentStatus === '11'
          ? 'Failed'
          : paymentStatus === '5'
            ? 'Directly'
            : '';
    return returnPaymentSpan;
  }

  getRespectiveMatIconNameOrClassName(
    paymentStatus: string | number,
    isClassName: boolean
  ): string {
    paymentStatus = paymentStatus.toString();
    let returnMatIconName: string = '';
    returnMatIconName = isClassName
      ? paymentStatus === '1' ||
        paymentStatus === '2' ||
        paymentStatus === '6' ||
        paymentStatus === '10' ||
        paymentStatus === '7' ||
        paymentStatus === '16' ||
        paymentStatus === '17'
        ? 'pending'
        : paymentStatus === '4' ||
            paymentStatus === '9' ||
            paymentStatus === '11' ||
            paymentStatus === '15'
          ? 'failed'
          : 'success'
      : paymentStatus === '1' ||
          paymentStatus === '2' ||
          paymentStatus === '6' ||
          paymentStatus === '10' ||
          paymentStatus === '7' ||
          paymentStatus === '16' ||
          paymentStatus === '17'
        ? 'watch_later'
        : paymentStatus === '4' ||
            paymentStatus === '9' ||
            paymentStatus === '11' ||
            paymentStatus === '15'
          ? 'error'
          : 'check_circle';
    return returnMatIconName;
  }

  convertPaymetStatusNameToNumericString(paymentStatus: string): string {
    paymentStatus =
      paymentStatus === 'INVOICE_CREATED'
        ? '1'
        : paymentStatus === 'PAYMENT_INITIATED'
          ? '2'
          : paymentStatus === 'PAYMET_SUCCESS'
            ? '3'
            : paymentStatus === 'PAYMENT_FAILED'
              ? '4'
              : paymentStatus === 'PAID_OTHER'
                ? '5'
                : paymentStatus === 'PAYMENT_PROCESSING'
                  ? '6'
                  : paymentStatus === 'SUBSCRIPTION_INITIATED'
                    ? '7'
                    : paymentStatus === 'SUBSCRIPTION_ACTIVE'
                      ? '8'
                      : paymentStatus === 'SUBSCRIPTION_FAILED'
                        ? '9'
                        : paymentStatus === 'SUBSCRIPTION_PROCESSING'
                          ? '10'
                          : paymentStatus === 'SUBSCRIPTION_PARTIAL_FAILED'
                            ? '11'
                            : paymentStatus === 'SUBSCRIPTION_COMPLETED'
                              ? '12'
                              : paymentStatus;
    return paymentStatus;
  }

  getAmountByDiscount(
    discount: number,
    amount: number,
    isAmount: boolean,
    isDiscount: boolean,
    invoiceIndex?: number,
    isPaidAmount?: boolean,
    isDueAmount?: boolean
  ): string {
    let strAmount = amount.toFixed(2);
    let amountWithDiscount =
      discount > 0 ? (amount = amount - discount) : amount;
    let strDiscount = discount.toFixed(2);
    let paidAmount = 0;
    if (isPaidAmount || isDueAmount) {
      paidAmount = this.getNetPaidAmount(
        this.invoiceInfoList.invoiceInfoList[invoiceIndex!].paymentDetails
          .transactions
      );
      console.log(
        this.invoiceInfoList.invoiceInfoList[invoiceIndex!].description,
        paidAmount
      );
    }
    let dueAmount = 0;
    if (isDueAmount) {
      dueAmount = amountWithDiscount - paidAmount;
    }
    let strAmountWithDiscount = amountWithDiscount.toFixed(2);
    let returnString: string =
      !isAmount && !isDiscount && !isPaidAmount && !isDueAmount
        ? strAmountWithDiscount
        : isAmount
          ? strAmount
          : isDiscount
            ? strDiscount
            : isPaidAmount
              ? paidAmount.toFixed(2)
              : isDueAmount
                ? dueAmount.toFixed(2)
                : '';
    return returnString;
  }

  checkPayNow(paymentStatus: string): boolean {
    let returnPayNowBool: boolean = false;
    parseInt(paymentStatus) === 1 ||
    parseInt(paymentStatus) === 2 ||
    parseInt(paymentStatus) === 4 ||
    parseInt(paymentStatus) === 7 ||
    parseInt(paymentStatus) === 9
      ? (returnPayNowBool = true)
      : (returnPayNowBool = false);
    return returnPayNowBool;
  }

  updatePaymentMethod(data: InvoiceInfo): void {
    console.log('udpatePaymentMethod trigegred!');
    this.showLoader = true;
    console.log('data: ', data);
    const invoiceId = data?.paymentDetails?.invoiceId;
    console.log('invoice id: ', invoiceId);
    this.globalApiService.updatePaymentMethod(invoiceId).subscribe({
      next: (resposne) => {
        this.showLoader = false;
        const data = resposne?.data;
        localStorage.setItem('cSessionId', data?.cSessionId);
        localStorage.setItem('invoiceId', data?.invoiceId);
        window.open(data?.checkoutUrl, '_blank');
      },
      error: (err: any) => {
        console.error('error: ', err);
        this.showLoader = false;
        this.notifier.notify('error', 'Unable to update the payment method.');
      }
    });
  }

  confirmTheUpdatePaymentMethod() {
    const invoiceId = localStorage.getItem('invoiceId');
    const cSessionId = localStorage.getItem('cSessionId');
    console.log('invoiceId, CsessionId are: ', invoiceId, cSessionId);
    this.globalApiService
      .confirmTheUpdatePaymentMethod(invoiceId!, cSessionId!)
      .subscribe({
        next: (response) => {
          this.notifier.notify(
            'success',
            'Payment Method Updated Successfully.'
          );
          localStorage.removeItem('invoiceId');
          localStorage.removeItem('cSessionId');
        },
        error: (err) => {
          console.log(err);
          this.notifier.notify(
            'error',
            'Payment Method Update Failed! Unable to Confirm the Updation.'
          );
        }
      });
  }

  onSwipe(evt: any, btnPos: number, isSwipe: boolean) {
    let position = '';
    if (isSwipe) {
      position =
        Math.abs(evt.deltaX) > 40 ? (evt.deltaX > 0 ? 'right' : 'left') : '';
    } else {
      position = btnPos === -1 ? 'right' : 'left';
    }
    // const y = Math.abs(evt.deltaY) > 40 ? (evt.deltaY > 0 ? 'down' : 'up') : '';
    console.log(`${position}`);
    if (position === 'right' && this.index > 0) {
      --this.index;
      this.startAnimation('enter');
    } else if (
      position === 'left' &&
      this.index < this.invoiceInfoList.invoiceInfoList.length - 1
    ) {
      ++this.index;
      this.startAnimation('enter');
    }
    console.log(this.index);
    this.mobileViewContent = this.invoiceInfoList.invoiceInfoList[this.index];
    console.log(this.mobileViewContent);
  }

  getMobileViewNameAndValue(matcher: string, isName: boolean): string | number {
    let returnNameOrValue: string | number = '';
    returnNameOrValue = isName
      ? matcher
      : matcher === 'Student'
        ? this.mobileViewContent!.studentName
        : matcher === 'Description'
          ? this.mobileViewContent!.description
          : matcher === 'Amount'
            ? (
                this.mobileViewContent!.amount -
                this.mobileViewContent!.discount
              ).toFixed(2)
            : matcher === 'Paid Amount'
              ? this.getAmountByDiscount(
                  this.mobileViewContent!.discount,
                  this.mobileViewContent!.amount,
                  false,
                  false,
                  this.index,
                  true
                )
              : matcher === 'Due Amount'
                ? this.getAmountByDiscount(
                    this.mobileViewContent!.discount,
                    this.mobileViewContent!.amount,
                    false,
                    false,
                    this.index,
                    false,
                    true
                  )
                : matcher === 'Status'
                  ? this.getPaymentStatus(this.mobileViewContent!.status)
                  : matcher === 'Payment Method'
                    ? this.mobileViewContent!.paymentTypeName
                    : matcher === 'Due By'
                      ? this.mobileViewContent!.dueDate
                      : // : matcher === 'Paid For'
                        // ? this.mobileViewContent!.paidFor
                        '';
    return returnNameOrValue;
  }

  makeInstalmentDates() {
    this.installmentDates = [];
    let installmentDate = moment(this.selectedInvoice?.dueDate).isBefore(
      moment(new Date())
    )
      ? moment(this.selectedInvoice?.dueDate)
      : moment(new Date());
    this.installmentDates.push(installmentDate.format('MM/DD/YYYY'));
    const recurringInterval: any = this.selectedInvoice?.recurringInterval;
    for (let i = 1; i < this.selectedInvoice!.iterations; i++) {
      const installmentDateClone = installmentDate.clone();
      this.installmentDates.push(
        installmentDateClone
          .add(
            i * this.selectedInvoice!.recurringIntervalCount,
            recurringInterval
          )
          .format('MM/DD/YYYY')
      );
    }
    // let installmentEndDate: moment.Moment = moment();
    // let momentRecurringInterval: moment.unitOfTime.DurationConstructor = 'M';
    // switch (this.selectedInvoice?.recurringInterval) {
    //   // ** weekly **
    //   case 'month':
    //     momentRecurringInterval = 'M';
    //     installmentEndDate = moment(
    //       this.selectedInvoice.isBackDate
    //         ? this.selectedInvoice.dueDate
    //         : new Date()
    //     ).add(
    //       this.selectedInvoice.recurringIntervalCount,
    //       momentRecurringInterval
    //     );
    //     break;
    //   case 'year':
    //     momentRecurringInterval = 'y';
    //     installmentEndDate = moment(
    //       this.selectedInvoice.isBackDate
    //         ? this.selectedInvoice.dueDate
    //         : new Date()
    //     ).add(
    //       this.selectedInvoice.recurringIntervalCount,
    //       momentRecurringInterval
    //     );
    //     break;
    //   // case 3:
    //   //   installmentEndDate = moment().add(this.installmentNumber * 2, 'M');
    //   //   break;
    //   // case 4:
    //   //   installmentEndDate = moment().add(this.installmentNumber * 3, 'M');
    //   //   break;
    //   // case 5:
    //   //   installmentEndDate = moment().add(this.installmentNumber * 6, 'M');
    //   //   break;
    //   // case 6:
    //   //   installmentEndDate = moment().add(this.installmentNumber)
    // }
    // this.installmentEndDate = installmentEndDate.format('MM-DD-YYYY');
    // for (
    //   let installmentDateIndex = 0;
    //   // installmentDateIndex < 13;
    //   installmentDateIndex < this.selectedInvoice!.iterations;
    //   installmentDateIndex++
    // ) {
    //   if (this.installmentDates.length === 0) {
    //     this.installmentDates[0] = moment(
    //       this.selectedInvoice?.isBackDate
    //         ? this.selectedInvoice.dueDate
    //         : new Date()
    //     ).format('MM/DD/YYYY');
    //   } else {
    //     this.installmentDates.push(
    //       moment(this.installmentDates[this.installmentDates.length - 1])
    //         .add(
    //           this.selectedInvoice!.recurringIntervalCount,
    //           momentRecurringInterval
    //         )
    //         .format('MM/DD/YYYY')
    //     );
    //   }
    // }
    // console.log(this.installmentDates);
    // console.log(this.installmentEndDate);
  }

  setPayNowContent(InvoiceInfoIndex: number) {}

  // getPaymentTypeName(paymentTypeId: number): string {
  //   let returnPaymentType: string = "";
  //   this.paymentTypes.forEach((paymentType, paymentTypeIndex) => {
  //     if ((paymentType.paymentTypeId = paymentTypeId)) {
  //       returnPaymentType = paymentType.paymentTypeName;
  //     }
  //   });
  //   return returnPaymentType;
  // }

  getPaymentUrl(invoiceId: string) {
    if (this.termCheck1) {
      if (!this.getPaymentUrlClicked) {
        this.getPaymentUrlClicked = true;
        this.globalApiService.getPaymentUrl(invoiceId).subscribe(
          (response: any) => {
            console.log(response);
            this.getPaymentUrlClicked = false;
            if (response.data) {
              window.location.href = response.data;
            }
          },
          (error) => {
            this.getPaymentUrlClicked = false;
            console.log(error);
            this.notifier.notify('error', 'Unable to generate payment');
          }
        );
      }
    } else {
      this.notifier.notify('error', `Please agree to the T&C's`);
    }
  }

  getAmountByInstallment(isInstallmentTotal: boolean): string {
    console.log(this.isPaymentOrInstallment);
    let returnAmount = 0;
    // if (this.installmentNumber === 0) {
    //   this.installmentNumber = this.selectedInvoice!.maxInstallment;
    // }
    returnAmount =
      this.selectedInvoice!.amount - this.selectedInvoice!.discount;
    if (this.isPaymentOrInstallment === 1) {
      returnAmount = returnAmount / this.selectedInvoice!.iterations;
      // if (this.selectedInvoice!.iterations >= 3) {
      //   returnAmount = returnAmount + (returnAmount / 100) * 3;
      // }
    }
    // returnAmount = Math.ceil(returnAmount);
    if (isInstallmentTotal) {
      returnAmount = returnAmount * this.selectedInvoice!.iterations;
    }
    return returnAmount.toFixed(2);
  }

  getTransactionCharge(isInstallmentTotal: boolean): string {
    let returnTransactionCharge: string = '';
    if (isInstallmentTotal) {
      returnTransactionCharge = (
        this.selectedInvoice!.transactionCharges *
          this.selectedInvoice!.iterations +
        parseFloat(this.getAmountByInstallment(true))
      ).toFixed(2);
    } else {
      returnTransactionCharge = (
        this.selectedInvoice!.transactionCharges +
        parseFloat(this.getAmountByInstallment(false))
      ).toFixed(2);
    }
    return returnTransactionCharge;
  }

  // ** a cancellation (status 15) only cancels out the most recently paid
  // ** installment when money was actually taken back (amountReceived < 0).
  // ** a cancellation with amountReceived === 0 didn't refund anything, so
  // ** the prior installment remains a valid successful payment.
  private getNetPaidAmount(transactions: transaction[]): number {
    const paidTransactions = transactions.filter(
      (txn: transaction) =>
        txn.paymentStatus !== 4 &&
        txn.paymentStatus !== 9 &&
        txn.paymentStatus !== 15 &&
        txn.paymentStatus !== 6 &&
        txn.paymentStatus !== 10
    );
    const refundedTransactionsCount = transactions.filter(
      (txn: transaction) => txn.paymentStatus === 15 && txn.amountReceived < 0
    ).length;
    const netPaidTransactions = paidTransactions.slice(
      0,
      Math.max(0, paidTransactions.length - refundedTransactionsCount)
    );
    return netPaidTransactions.reduce(
      (sum, txn) => sum + txn.amountReceived,
      0
    );
  }

  getPaidAmount(): string {
    return this.getNetPaidAmount(
      this.paymentHistory?.paymentDetails.transactions || []
    ).toFixed(2);
  }

  getDueAmount(): string {
    const returnDueAmount =
      this.paymentHistory!.amount -
      this.paymentHistory!.discount -
      this.getNetPaidAmount(
        this.paymentHistory?.paymentDetails.transactions || []
      );
    return returnDueAmount.toFixed(2);
  }

  openDueModal(invoice: InvoiceInfo) {
    this.selectedInvoice = invoice;
    this.isPaymentOrInstallment = invoice.allowInstallment ? 1 : 0;
    this.installmentNumber = 2;
    this.termCheck1 = false;
    this.makeInstalmentDates();
    // this.showPayNowDueModel = true;
    this.isInstallment = true;
  }

  installmentPay() {
    if (this.isPaymentOrInstallment === 0) {
      this.getPaymentUrl(this.selectedInvoice!.invoiceId);
    } else if (this.isPaymentOrInstallment === 1) {
      console.log('in installment pay');
      if (this.termCheck1) {
        this.showLoader = true;
        this.globalApiService
          .payByInstallments(this.selectedInvoice!.invoiceId)
          .subscribe(
            (response: any) => {
              console.log('Subscription info ', response);
              // if (response.data) {
              this.showLoader = false;
              //   window.location.href = response.data;
              // }
              this.stripePaymentServcie.setPaymentInfo({
                clientSecret: response.data.clientSecret || '',
                invoiceData: this.selectedInvoice
              });
              this.router.navigateByUrl('/stripe-payment');
            },
            (error) => {
              this.showLoader = false;
              console.log(error);
              this.notifier.notify('error', 'Unable to generate payment');
            }
          );
      } else {
        this.notifier.notify('error', `Please agree to the T&C's`);
      }
    }
  }

  // getPaymentHistory(invoiceId: string) {
  //   this.globalApiService.getPaymentHistory(true, invoiceId).subscribe({
  //     next: (res: any) => {
  //       this.showLoader = true;
  //       console.log(res);
  //       this.paymentHistory = res;
  //       this.paymentHistory?.transactions.forEach(
  //         (transaction, transactionIndex) => {
  //           try {
  //             parseInt(transaction.paymentStatus);
  //           } catch (error) {
  //             transaction.paymentStatus =
  //               this.convertPaymetStatusNameToNumericString(
  //                 transaction.paymentStatus
  //               );
  //           }
  //         }
  //       );
  //       this.showLoader = false;
  //       this.paymentCardClicked = true;
  //     },
  //     error: (err: any) => {
  //       console.log(err);
  //       this.notifier.notify('error', 'Unable to fetch payment history');
  //     },
  //   });
  // }

  getStartDate() {}

  setPaymentHistory(invoiceIndex: number) {
    this.showLoader = true;
    this.successfulTransactions = [];
    this.paymentHistory = this.invoiceInfoList.invoiceInfoList[invoiceIndex];
    // ** filter out the statuses with 6 and 10
    // ** Handling in getInvoiveList API call
    // this.paymentHistory.paymentDetails.transactions =
    //   this.paymentHistory.paymentDetails.transactions.filter(
    //     (transaction) =>
    //       transaction.paymentStatus !== 6 && transaction.paymentStatus !== 10
    //   );
    this.paymentHistory.paymentDetails.transactions.forEach(
      (transaction, transactionIndex) => {
        if (transaction.paymentStatus === 8) {
          transaction.paymentStatus = 3;
        }
      }
    );
    const paidTransactions = this.paymentHistory.paymentDetails.transactions.filter(
      (txn: transaction) => {
        return txn.paymentStatus !== 4 && txn.paymentStatus !== 9 && txn.paymentStatus !== 15;
      }
    );
    const refundedTransactionsCount =
      this.paymentHistory.paymentDetails.transactions.filter(
        (txn: transaction) => txn.paymentStatus === 15 && txn.amountReceived < 0
      ).length;
    // ** only a cancellation that actually refunded money (amountReceived < 0)
    // ** cancels out the most recent paid installment
    this.successfulTransactions = paidTransactions.slice(
      0,
      Math.max(0, paidTransactions.length - refundedTransactionsCount)
    );
    console.log(this.paymentHistory);
    this.selectedInvoice = this.invoiceInfoList.invoiceInfoList[invoiceIndex];
    if (
      (this.paymentHistory.paymentDetails.transactions !== null ||
        this.paymentHistory.paymentDetails.transactions !== undefined) &&
      this.successfulTransactions.length > 0
    ) {
      const dueDate = moment(this.selectedInvoice.dueDate, 'MM-DD-YYYY');
      const firstTransactionDate = moment(
        this.successfulTransactions[0].transactionDate,
        'MM-DD-YYYY'
      );
      const date = dueDate.isBefore(firstTransactionDate)
        ? dueDate
        : firstTransactionDate;
      const nextInstallmentCount =
        this.successfulTransactions.length *
        this.selectedInvoice.recurringIntervalCount;
      date.add(
        nextInstallmentCount,
        this.selectedInvoice.recurringInterval === 'month' ? 'month' : 'year'
      );
      this.nextInstallmentDate = date.format('MM-DD-YYYY');
      // let momentRecurringInterval: moment.unitOfTime.DurationConstructor = 'M';
      // let lastTransactionDate =
      //   this.paymentHistory.paymentDetails.transactions[
      //     this.paymentHistory.paymentDetails.transactions.length - 1
      //   ].transactionDate;
      // momentRecurringInterval =
      //   this.paymentHistory.recurringInterval === 'month'
      //     ? 'M'
      //     : this.paymentHistory.recurringInterval === 'year'
      //     ? 'y'
      //     : 'M';
      // console.log(moment(lastTransactionDate));
      // if (this.paymentHistory.isBackDate) {
      //   this.nextInstallmentDate = moment(this.paymentHistory.dueDate)
      //     .add(
      //       this.paymentHistory.recurringIntervalCount,
      //       momentRecurringInterval
      //     )
      //     .format('MM-DD-YYYY');
      // } else {
      //   this.nextInstallmentDate = moment(lastTransactionDate, 'MM-DD-YYYY')
      //     .add(
      //       this.paymentHistory.recurringIntervalCount,
      //       momentRecurringInterval
      //     )
      //     .format('MM-DD-YYYY');
      // }
    }
    // this.makeInstalmentDates();

    this.showLoader = false;
    this.paymentCardClicked = true;
  }

  downloadInvoice(transaction: transaction): void {
    this.showLoader = true;
    this.globalApiService.downloadInvoice(transaction?.receiptId).subscribe({
      next: (response) => {
        this.showLoader = false;
        const data = response?.data;
        window.open(data?.invoiceUrl, '_blank');
      },
      error: (err) => {
        this.showLoader = false;
        console.log('err - download invoice: ', err);
        this.notifier.notify('error', 'Unable to download the invoice.');
      }
    });
  }

  checkoutInvoice(transaction: transaction): void {
    this.showLoader = true;
    this.globalApiService.downloadInvoice(transaction?.receiptId).subscribe({
      next: (response) => {
        this.showLoader = false;
        const data = response?.data;
        window.open(data?.invoiceUrl, '_blank');
      },
      error: (err) => {
        this.showLoader = false;
        console.log('err - checkout invoice: ', err);
        this.notifier.notify('error', 'Unable to checkout the invoice.');
      }
    });
  }
}
